import React from 'react';

import { Box, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { FIELD_HEIGHT, LABEL_WIDTH, VALUE_WIDTH } from './constants';
import { type RowProps } from './types';

const inlineStyles = xcss({
	flexDirection: 'row',
	columnGap: 'space.100',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${FIELD_HEIGHT}px`,
	alignItems: 'center',
});

const blockStyles = xcss({
	flexDirection: 'column',
	rowGap: 'space.100',
	justifyContent: 'center',
});

const fieldStyles = {
	inline: inlineStyles,
	block: blockStyles,
};

const labelStyles = xcss({
	color: 'color.text',
	font: token('font.body.UNSAFE_small'),
	fontWeight: token('font.weight.semibold'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${LABEL_WIDTH}px`,
});

const valueStyles = xcss({
	color: 'color.text',
	font: token('font.body'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	lineHeight: '16px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${VALUE_WIDTH}px`,
});

const Row = ({ children, label, variant, htmlFor }: RowProps) => {
	return children ? (
		<>
			<Flex xcss={fieldStyles[variant]}>
				<Box as="label" htmlFor={htmlFor} xcss={labelStyles}>
					{label}
				</Box>
				<Box as={typeof children === 'string' ? 'span' : 'div'} xcss={valueStyles}>
					{children}
				</Box>
			</Flex>
		</>
	) : null;
};

export { Row };
